export default (builder) =>
  builder.mutation({
    query: (user) => ({ url: `/users`, method: 'POST', body: user }),
  });
